import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  basePriceARS: number;
  className?: string;
  strikeThrough?: boolean;
}
export const PriceDisplay: React.FC<PriceDisplayProps> = ({
  basePriceARS,
  className = '',
  strikeThrough = false
}) => {
  const [formattedPrice, setFormattedPrice] = useState(`$${basePriceARS.toLocaleString('es-AR')} ARS`);
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    let rate = 1;
    let symbol = '$';
    let code = 'ARS';
    let formatLocale = 'es-AR';
    // Simulated Shopify Markets logic
    if (locale.startsWith('en-US')) {
      rate = 1 / 1000; // 1 USD = 1000 ARS
      symbol = '$';
      code = 'USD';
      formatLocale = 'en-US';
    } else if (locale.startsWith('en-GB') || locale === 'en-UK') {
      rate = 1 / 1250; // 1 GBP = 1250 ARS
      symbol = '£';
      code = 'GBP';
      formatLocale = 'en-GB';
    } else if (/^(de|fr|it|es-ES)/.test(locale)) {
      rate = 1 / 1100; // 1 EUR = 1100 ARS
      symbol = '€';
      code = 'EUR';
      formatLocale = 'es-ES';
    }
    const convertedPrice = basePriceARS * rate;
    const formatter = new Intl.NumberFormat(formatLocale, {
      minimumFractionDigits: code === 'ARS' ? 0 : 2,
      maximumFractionDigits: code === 'ARS' ? 0 : 2
    });
    setFormattedPrice(`${symbol}${formatter.format(convertedPrice)} ${code}`);
  }, [basePriceARS]);
  return <span className={`${className} ${strikeThrough ? 'line-through opacity-70' : ''}`} data-id="element-145">
      {formattedPrice}
    </span>;
};